import apiEventsSearchList from '@/api/events-search'

const state = {
  data: [],
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getEventsSearchListStart: '[events search list] Get events search list start',
  getEventsSearchListSuccess:
    '[events search list] Get events search list success',
  getEventsSearchListFailure:
    '[events search list] Get events search list failure',
}

export const actionTypes = {
  getEventsSearchList: '[events search list] Get events search list',
}

const mutations = {
  [mutationTypes.getEventsSearchListStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getEventsSearchListSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getEventsSearchListFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getEventsSearchList](context, {params}) {
    context.commit(mutationTypes.getEventsSearchListStart)
    return new Promise((resolve) => {
      apiEventsSearchList
        .getEventsSearchList(params)
        .then((response) => {
          context.commit(mutationTypes.getEventsSearchListSuccess, response)
          resolve(response)
        })
        .catch((error) => {
          context.commit(mutationTypes.getEventsSearchListFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
